/**
 * The expanded (non-collapsed) sidebar's width in pixels. Used by anything
 * that must position itself relative to the sidebar's right edge (flyouts,
 * popouts, context menus) without reading layout from the DOM.
 *
 * Mirrors the `w-64` Tailwind class applied to the expanded sidebar rail and
 * `RELAY_FLYOUT_SURFACE_CLASS` in `CollapsedSidebar.tsx` (Tailwind's `64`
 * spacing step is 256px) — keep both in sync if the rail width ever changes.
 */
export const EXPANDED_SIDEBAR_WIDTH_PX = 256;

/**
 * The collapsed sidebar's width in pixels. Mirrors the `w-16` Tailwind class
 * applied by `SidebarLayout` (Tailwind's `16` spacing step is 64px).
 */
export const COLLAPSED_SIDEBAR_WIDTH_PX = 64;
